///jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\BookListScreen.jsx
import { Table, Button, Row, Col, Container } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash, FaEye, FaEyeSlash, FaSort } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import {
  useGetBooksQuery,
  useDeleteBookMutation,
  useToggleBookVisibilityMutation,
} from '../../slices/booksApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';




const BookListScreen = () => {
  const { pageNumber } = useParams();

  const [searchTerm, setSearchTerm] = useState('');

  const [deleteBook, { isLoading: loadingDelete }] = useDeleteBookMutation();
  const [toggleVisibility, { isLoading: loadingVisibility }] = useToggleBookVisibilityMutation();

  const [sortConfig, setSortConfig] = useState({
    key: 'numeroEditeur', // Tri initial par ObjectId
    direction: 'desc', // Ordre décroissant par défaut
  });

  const deleteHandler = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette fiche ?')) {
      try {
        await deleteBook(id);
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };
  
  const navigate = useNavigate();

  const goToCreateBookPage = () => {
    navigate('/admin/bookadd');
  };
  

  const toggleVisibilityHandler = async (id) => {
    try {
      await toggleVisibility(id);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };


  const { data, isLoading, error, refetch } = useGetBooksQuery({
    pageNumber,
    isAdminSpace: true,
    sortKey: sortConfig.key,
    sortDirection: sortConfig.direction,
    parPage:28,
    keyword: searchTerm,
  });
  
  // Fonction pour changer le tri
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
    refetch(); // Rafraîchir les données
  };


  return (
    <Container>
      <Row className="align-items-center">
        <Col>
        <h1 style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleSort('numeroEditeur')}>Tous les livres <FaSort /></h1>
        </Col>

        <Col xs={12} md={4} className="my-2 my-md-0">
          <input
            type="text"
            className="form-control"
            placeholder="Trier par titre"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>


        <Col className="text-end">
          <Button className="my-3" onClick={goToCreateBookPage}>
            <FaPlus /> Ajouter un livre
          </Button>
        </Col>
      </Row>

{/* 
      {loadingCreate && <Loader />}
*/}

      {loadingDelete && <Loader />}
      {loadingVisibility && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error.data.message}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th onClick={() => handleSort('title')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Titre <FaSort /></th>
                {/* <th onClick={() => handleSort('authors')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Auteurs <FaSort /></th> */}
                <th onClick={() => handleSort('author1')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Auteur 1 <FaSort /></th>
                <th onClick={() => handleSort('author2')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Auteur 2 <FaSort /></th>
                <th onClick={() => handleSort('translator')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Traducteur <FaSort /></th>

                <th onClick={() => handleSort('booksCollection')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Collection <FaSort /></th>
                <th onClick={() => handleSort('price')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Prix (€) <FaSort /></th>
                <th onClick={() => handleSort('isVisible')} style={{ cursor: 'pointer', whiteSpace: 'nowrap', textAlign: 'center' }}>Actions <FaEye style={{ color: 'grey' }} /></th>
              </tr>
            </thead>
            <tbody>
              {data?.books.map((book) => (
                <tr key={book._id}>
                  <td>
                    <Link
                      to={`/admin/book/${book._id}/edit`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      title="Modifier la fiche"
                    >
                      {book.title}
                    </Link>
                  </td>
                  {/* <td>
                    {book.authors?.length > 0
                      ? book.authors.map((author, index) => (
                        
                          // Affichage des noms de famille avec une virgule entre les auteurs
                          <span key={author._id}>
                            {author.lastName}
                            {index < book.authors.length - 1 && ', '}
                          </span>
                        ))
                      : 'Non spécifié'}
                  </td> */}
                  <td>{book.author1 ? `${book.author1.firstName || ''} ${book.author1.lastName || ''}`.trim() : '—'}</td>
                  <td>{book.author2 ? `${book.author2.firstName || ''} ${book.author2.lastName || ''}`.trim() : '—'}</td>
                  <td>{book.translator ? `${book.translator.firstName || ''} ${book.translator.lastName || ''}`.trim() : '—'}</td>




                  <td>{book.booksCollection?.name || 'Non spécifié'}</td>
                  <td style={{ textAlign: 'right' }}>{book.price} €</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <Button
                      as={Link}
                      to={`/admin/book/${book._id}/edit`}
                      variant="light"
                      className="btn-sm mx-2"
                      title="Modifier la fiche"
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => toggleVisibilityHandler(book._id)}
                      title={book.isVisible ? 'Cacher la fiche' : 'Rendre la fiche visible'}
                    >
                      {book.isVisible ? (
                        <>
                          <FaEye style={{ color: 'turquoise' }} />
                          <FaEyeSlash style={{ color: 'grey' }} />
                        </>
                      ) : (
                        <>
                          <FaEye style={{ color: 'grey' }} />
                          <FaEyeSlash style={{ color: 'red' }} />
                        </>
                      )}
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => deleteHandler(book._id)}
                      title={
                        book.isVisible
                          ? 'Seules les fiches non visibles peuvent être supprimées'
                          : 'Supprimer la fiche'
                      }
                      disabled={book.isVisible}
                    >
                      <FaTrash style={book.isVisible ? { color: 'grey' } : { color: 'red' }} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>

          </Table>
          <Paginate pages={data.pages} page={data.page} isAdmin={true} basePath="/admin/booklist" />
        </>
      )}
    </Container>
  );
};

export default BookListScreen;
